import { api } from '@/utils';

export default {
  name: 'StakeHolderReferences',
  components: {},
  props: {
    inputForm: {
      type: Object,
      default: undefined,
    },
    inputFormType: {
      type: String,
      default: '',
    },
    inputFormTypes: {
      type: Array,
      default: () => [],
    },
    ports: {
      type: Array,
      default: () => [],
    },
    enums: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    apiVersion: 1,
    pageSize: 9999999,
    stakeHolders: [],
    stakeHolderValues: [],
    title: 'Relevant stakeholders',
    formFields: {
      stakeHolder: {
        name: 'stakeHolder',
        label: 'StakeHolder',
      },
      references: {
        name: 'references',
        label: 'References',
        validation: 'required',
      },
    },
  }),
  computed: {},
  methods: {
    addStakeHolder() {
      this.stakeHolders.push({
        stakeHolderId: 0,
        references: [],
      });
    },
    deleteStakeHolder(stakeHolder) {
      this.stakeHolders = this.stakeHolders.filter(sh => sh !== stakeHolder);
    },
    fetchStakeHolders() {
      // BASEURL
      let url = '/stakeholders?';

      // Page and Pagesize
      url += `&page=1&page-size=${this.pageSize}`;

      api
        .get(url)
        .then((response) => {
          this.stakeHolderValues = response.data.map(sh => ({ value: sh.id, text: sh.name }));
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onInputFormSaved() {
      this.$validator
        .validateAll()
        .then((isValid) => {
          if (isValid) {
            const stakeHoldersToSend = this.stakeHolders
              .filter(sh => sh.id)
              .map(sh => ({
                stakeholderId: sh.id,
                references: [...sh.references],
              }));

            this.$eventHub.$emit('fetch-stakeholder-references', stakeHoldersToSend);
          } else {
            this.$eventHub.$emit('fetch-stakeholder-references', null);
          }
        })
        .catch(() => {
          console.log('something went wrong in file StakeHolderReferences.controller.js method onInputFormSaved');
        });
    },
  },
  watch: {
    inputForm() {
      if (this.inputForm != null) {
        if (this.inputForm.additionalStakeholderReferences != null && this.inputForm.additionalStakeholderReferences.length > 0) {
          this.stakeHolders = this.inputForm.additionalStakeholderReferences.map(sh => ({ id: sh.stakeholderId, references: sh.references }));
        }
      }
    },
  },
  created() {
    this.addStakeHolder();
    this.fetchStakeHolders();
    this.$eventHub.$on('on-input-form-saved', this.onInputFormSaved);
  },
};
